// src/i18n/shell.ts —— 06 agent-portal A-01 / A-01b / A-02 全局框架；06 未给英文或未给键的标「本计划定稿」（待回写 06）
export const I18N_AGENT_SHELL = {
  zh: {
    // 2026-10-15 空闲自动退出 / 最长在线（06 A-00 全局框架 · 会话保持）
    idleTitle: '仍在使用吗？',
    idleWarn: '即将因长时间未操作自动退出（倒计时 {n} 秒）',
    idleContinue: '继续使用',
    idleLoggedOut: '因长时间未操作，已自动退出',
    sessionMaxAge: '登录已超过 {n} 小时，请重新登录',
    sessionExpired: '登录已失效，请重新登录',
    account: '登录账号', // [改写 key] 06 A-01
    fcpTitle: '首次登录，请修改初始密码',
    fcpSub: '为保障账户安全，请先修改由平台或上级设置的初始密码，完成后需重新登录。',
    fcpSubmit: '确认修改',
    fcpPwdPh: '8-20 位，含字母与数字', // 06 A-01b 新密码 placeholder；键名本计划定稿
    toastPwdRelogin: '密码已修改，请重新登录',
    errOldPwd: '当前密码错误',
    errPwdRule: '新密码至少 8 位且需包含字母与数字，两次输入需一致',
    uplinePlatform: 'GoodPayU 平台', // 06 A-02「顶级=GoodPayU 平台」；键名本计划定稿
    spendRate: '充值差价', // [改写 key] D10 / X-42；0045 返佣废弃改「差价」
    hHome: '推广链接、售价与本月佣金', // [改写 key] 0045
    hSubs: '新增下级分销商并查看其售价', // [改写 key] 0045（代理不能改下级售价）
    hSpend: '我名下用户的每一笔卡消费（卡消费不产生佣金）', // [改写 key] X-42（页头副题属外壳 pageHint）
    hCommissions: '每一笔佣金的来源与结算状态', // [改写 key] 2026-10-18 代理端不展示层级
  },
  en: {
    idleTitle: 'Still there?',
    idleWarn: 'You will be signed out soon due to inactivity ({n}s left)',
    idleContinue: 'Stay signed in',
    idleLoggedOut: 'You were signed out due to inactivity',
    sessionMaxAge: 'You have been signed in for more than {n} hours. Please sign in again.',
    sessionExpired: 'Your session has expired. Please sign in again.',
    account: 'Login account',
    fcpTitle: 'First sign-in: change your password',
    fcpSub: 'For your security, change the initial password set by the platform or your upline. You will need to sign in again afterwards.', // 本计划定稿
    fcpSubmit: 'Confirm', // 本计划定稿
    fcpPwdPh: '8-20 characters, letters and digits', // 本计划定稿
    toastPwdRelogin: 'Password changed. Please sign in again', // 本计划定稿
    errOldPwd: 'Current password is incorrect', // 本计划定稿
    errPwdRule: 'New password must be at least 8 characters with letters and digits, and both entries must match', // 本计划定稿
    uplinePlatform: 'GoodPayU (platform)',
    spendRate: 'Top-up markup',
    hHome: 'Referral links, prices and commissions',
    hSubs: 'Add sub-agents and view their prices',
    hSpend: 'Every card transaction from my users (spend earns no commission)',
    hCommissions: 'Source and settlement of each commission',
  },
} as const;

// TD-805：与原型字典重名的键须显式登记才覆盖原型值（06 A-01 / A-02 [改写 key]）
export const REWRITES_AGENT_SHELL: readonly string[] = ['account', 'spendRate', 'hSpend', 'hHome', 'hSubs', 'hCommissions'];
